import {call, put, takeEvery} from 'redux-saga/effects';
import service from '../../services/';
import {errorBrowsePane, initBrowsePane, fetchBrowsePane} from "../browse/actions";
import { chooseServiceGenerator } from './utils';


function* startOcularisBrowsemode(action) {
    const {pane, width, height, camId, streamId} = action;
    const token = window.localStorage.getItem('token');

    try {
        yield put(fetchBrowsePane(pane));
        yield call(() => service.initBrowse({ pane, token, width, height, camId, streamId }));
        yield call(() => service.startBrowse(token, pane));
        yield put(initBrowsePane(pane, camId));
    } catch (e) {
        yield put(errorBrowsePane(pane))
    }
}

function* startCayugaBrowsemode(action) {
    const {pane, width, height, camId, streamId} = action;
    const token = window.localStorage.getItem('token');

    try {
        yield put(initBrowsePane(pane, camId));
    } catch (e) {
        yield put(errorBrowsePane(pane))
    }
}

export default function* () {
    yield takeEvery('startBrowsePane', chooseServiceGenerator,
        {fn: startOcularisBrowsemode, args: []}, 
        {fn: startCayugaBrowsemode, args: []}
    );
}